import store from '../store'
import { isEmpty } from '@/common/utils'
import { ErrCustom } from '../error/custom-error'
import { PixTransaction } from '../domain/PixTransaction' //eslint-disable-line
import { Card } from '../domain/Card' //eslint-disable-line
import { SuccessfulTransaction } from '../domain/SuccessfulTransaction' //eslint-disable-line

export const TRANSACTION_KEY = 'transaction_id'
export const LATEST_PIX_QRCODE_KEY = 'latest_pix_qrcode'
export const LATEST_CARD_KEY = 'latest_card'
export const CONFIRMATION_KEY = 'confirmation'

class ErrNoTransaction extends ErrCustom { }
class ErrConfirmationData extends ErrCustom { }

/**
 * @param {String} val
 * @returns {Promise}
 */
const storeTransactionId = async val => store.set(TRANSACTION_KEY, val)

/**
 * @param {SuccessfulTransaction} val
 * @returns {Promise}
*/
const storeSuccessfulTransaction = val => store.set(CONFIRMATION_KEY, val)

/**
 * @param {PixTransaction} val
 * @returns {Promise<Void>}
 */
const storePixTransaction = val => store.set(LATEST_PIX_QRCODE_KEY, val)

/**
 * @param {Card} val
 * @returns {Promise<Void>}
 */
const storeCard = val => store.set(LATEST_CARD_KEY, val)

/**
 * @returns {Promise<SuccessfulTransaction>}
 */
const loadSuccessfulTransaction = async () => {
  const data = await store.get(CONFIRMATION_KEY)

  if (isEmpty(data)) {
    return Promise.reject(new ErrConfirmationData('Não há dados de confirmação'))
  }

  return Promise.resolve(data)
}

/**
 * load current user data
 * @returns {Promise<String>}
 */
const loadTransactionId = async () => {
  const data = await store.get(TRANSACTION_KEY)

  if (isEmpty(data)) {
    return Promise.reject(new ErrNoTransaction('Nenhuma transação iniciada.'))
  }

  return Promise.resolve(data)
}

/**
 * load latest pix transaction
 * @returns {Promise<PixTransaction>}
 */
const loadPixTransaction = async () => {
  return await store.get(LATEST_PIX_QRCODE_KEY)
}

/**
 * load latest card tokenized
 * @returns {Promise<Card>}
 */
const loadCard = async () => {
  return await store.get(LATEST_CARD_KEY)
}

export {
  loadTransactionId,
  loadSuccessfulTransaction,
  loadPixTransaction,
  loadCard,
  storeTransactionId,
  storeSuccessfulTransaction,
  storePixTransaction,
  storeCard
}
